/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequest
 */
export interface FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequest {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequest
     */
    Token: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequest interface.
 */
export function instanceOfFxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequest(value: object): value is FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequest {
    if (!('Token' in value) || value['Token'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequestFromJSON(json: any): FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequest {
    return FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'Token': json['Token'],
    };
}

export function FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequestToJSON(json: any): FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequest {
    return FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequestToJSONTyped(value?: FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Token': value['Token'],
    };
}

